import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { BrowserRouter } from 'react-router-dom'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    {/* Browser Router provides ability to use routes inside our application. It is a parent component and can have only one child*/}
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
)
reportWebVitals()
